module.exports = __webpack_public_path__ + "img/156.552641dd.jpg";